import React, { useEffect, useState } from "react"
import { useParams, useNavigate, useSearchParams } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
  Alert,
} from "reactstrap"
import {
  AcceptPartnerCockpitInvitation,
  RejectPartnerCockpitInvitation,
} from "helpers/backend_helper"
import { withTranslation } from "react-i18next"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useLoading } from "helpers/custom_hooks"

const PartnerCockpitInvitation = ({ t }) => {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const setLoading = useLoading()
  const navigate = useNavigate()
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [processing, setProcessing] = useState(false)

  const partnerCockpitName = searchParams.get("name")

  const handleAccept = async () => {
    try {
      setProcessing(true)
      await AcceptPartnerCockpitInvitation(id)
      setSuccess(t("You have successfully joined the partner cockpit"))
      setTimeout(() => navigate("/partner-cockpit"), 2000)
    } catch (err) {
      setError(t("Failed to accept invitation"))
    } finally {
      setProcessing(false)
    }
  }

  const handleReject = async () => {
    try {
      setProcessing(true)
      await RejectPartnerCockpitInvitation(id)
      setSuccess(t("Invitation has been rejected"))
      setTimeout(() => navigate("/partner-cockpits"), 2000)
    } catch (err) {
      setError(t("Failed to reject invitation"))
    } finally {
      setProcessing(false)
    }
  }

  useEffect(() => {
    setLoading(false)
  }, [])

  if (error) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container>
            <Row className="justify-content-center mt-5">
              <Col md="6">
                <Alert color="danger">{error}</Alert>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={t("Partner Cockpit")}
            breadcrumbItem={t("Invitation")}
          />
          <Row className="justify-content-center">
            <Col md="8" lg="6" xl="5">
              <Card>
                <CardBody>
                  <div className="text-center mb-4">
                    <h4 className="mb-3">
                      {t("You have been invited to join Partner Cockpit:")}
                    </h4>
                    <h2 className="text-primary mb-3">{partnerCockpitName}</h2>
                    <p className="text-muted">
                      {t("Please accept or reject this invitation")}
                    </p>
                  </div>

                  {success ? (
                    <Alert color="success" className="text-center">
                      {success}
                    </Alert>
                  ) : (
                    <div className="d-flex justify-content-center gap-3">
                      <Button
                        color="primary"
                        onClick={handleAccept}
                        disabled={processing}
                        className="px-4"
                      >
                        {processing ? (
                          <Spinner size="sm" className="me-2" />
                        ) : (
                          <i className="bx bx-check-circle me-2" />
                        )}
                        {t("Accept")}
                      </Button>
                      <Button
                        color="danger"
                        onClick={handleReject}
                        disabled={processing}
                        className="px-4"
                      >
                        {processing ? (
                          <Spinner size="sm" className="me-2" />
                        ) : (
                          <i className="bx bx-x-circle me-2" />
                        )}
                        {t("Reject")}
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(PartnerCockpitInvitation)
